import { ParsedUrlQuery } from "querystring";
import { getPathSegments } from "./getPathSegments";

/**
 * @deprecated
 * Please don't use this!
 * If you're tempted to use it you're probably doing the wrong thing!
 *
 * Ask Web Arch team for more information.
 *
 * TODO WA-649 - remove this
 */
export function getColourPathParam(query: ParsedUrlQuery) {
  const path = getPathSegments(query);
  return path.length > 2 ? path[1] : undefined;
}
